import { Calendar } from 'lucide-react';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { FundFormData } from './types';

interface TimelineSectionProps {
  formData: FundFormData;
  errors: Record<string, string>;
  onInputChange: (field: keyof FundFormData, value: string) => void;
}

export function TimelineSection({
  formData,
  errors,
  onInputChange,
}: TimelineSectionProps) {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <Calendar className="h-5 w-5 text-slate-700" />
          <CardTitle>Timeline & Terms</CardTitle>
        </div>
        <CardDescription>
          Fund timeline, terms, and closing dates
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label htmlFor="first_closing_date">First Closing Date</Label>
            <Input
              id="first_closing_date"
              type="date"
              value={formData.first_closing_date}
              onChange={(e) =>
                onInputChange('first_closing_date', e.target.value)
              }
            />
          </div>
          <div>
            <Label htmlFor="final_closing_date">Final Closing Date</Label>
            <Input
              id="final_closing_date"
              type="date"
              value={formData.final_closing_date}
              onChange={(e) =>
                onInputChange('final_closing_date', e.target.value)
              }
            />
          </div>
          <div>
            <Label htmlFor="fund_term_years">Fund Term (Years)</Label>
            <Input
              id="fund_term_years"
              type="number"
              value={formData.fund_term_years}
              onChange={(e) => onInputChange('fund_term_years', e.target.value)}
              placeholder="10"
              className={errors.fund_term_years ? 'border-red-500' : ''}
            />
            {errors.fund_term_years && (
              <p className="text-sm text-red-600 mt-1">
                {errors.fund_term_years}
              </p>
            )}
          </div>
          <div>
            <Label htmlFor="extension_periods">Extension Periods</Label>
            <Input
              id="extension_periods"
              type="number"
              value={formData.extension_periods}
              onChange={(e) =>
                onInputChange('extension_periods', e.target.value)
              }
              placeholder="2"
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
